import './HistogramValueBottomAxisArea.css';
export var axisContainerStyle = '_9phcbi0-3-5-0';